import { render, staticRenderFns } from "./DodCustomerDetails.vue?vue&type=template&id=73d5642d&scoped=true&"
import script from "./DodCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./DodCustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./DodCustomerDetails.vue?vue&type=style&index=0&id=73d5642d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d5642d",
  null
  
)

export default component.exports